import { observable, runInAction, action, makeObservable } from "mobx";
import { API } from "General/API";
import { CoreStore, handleStoreState } from "Stores/RESTStore/CoreStore";
import { API_URL } from "General/APIEndpoints";

export type LinkLanguage = "en" | "de";

class ReleaseNotesStore extends CoreStore {
  data: Record<LinkLanguage, API_AdminReleaseNotes> = {
    de: {},
    en: {},
  };
  active = false;

  constructor() {
    super();

    makeObservable(this, {
      data: observable,
      active: observable,
      switch: action.bound,
      fetch: action.bound,
      edit: action.bound,
      setData: action.bound,
    });
  }

  clear() {
    this.data = {
      de: {},
      en: {},
    };
  }

  url() {
    return API_URL.ADMIN.updateReleaseNotes();
  }

  @handleStoreState()
  async fetch() {
    try {
      const notes: API_AdminReleaseNotes = await API.getData(this.url());
      runInAction(() => {
        this.data = { de: notes.germanNotes, en: notes.englishNotes };
        this.active = notes.active;
      });
    } catch (err) {
      throw err;
    }
  }

  @handleStoreState()
  async edit() {
    const { de, en } = this.data;
    const body: API_AdminReleaseNotes = {
      germanNotes: de,
      englishNotes: en,
      active: this.active,
    };

    try {
      await API.editData(this.url(), body);
    } catch (err) {
      throw err;
    }
  }

  switch(value: boolean) {
    this.active = value;
  }

  setData(lang: LinkLanguage, prop: keyof API_ReleaseNotes, value: string) {
    this.data[lang] = { ...this.data[lang], [prop]: value };
  }
}

export const releaseNotesStore = new ReleaseNotesStore();
